<app-layout-crud-index
    [titulo]="title"
    [length]="length"
    [dataSource]="dataSource"
    [filterFields]="filterFields"
    [configColumns]="configColumns"
    [displayedColumns]="displayedColumns"
    (onChangePage)="changePage($event)"
    (onFilter)="filter($event)"
    (onSubmitAdvancedFilter)="submitAdvancedFilter($event)"
    (onOpenShow)="openShow($event)"
    (onOpenNew)="openNew($event)"
    (onOpenEdit)="openEdit($event)"
    (onOpenDelete)="openDelete($event)"
    (onResetFilter)="resetFilter()"
    (settings)="openSettings($event)">
    <table-responsive
        table
        [length]="length"
        [insideTheMenu]="['DeleteButton','EditButton','ShowButton']"
        (changePage)="changePage($event)"
        (filter)="filter($event)"
        [displayedColumns]="displayedColumns"
        [dataSource]="dataSource"
        [configColumns]="configColumns"
        (openShow)="openShow($event)"
        (openNew)="openNew($event)"
        (openEdit)="openEdit($event)"
        (openDelete)="openDelete($event)"
        [showLock]="false"
        [lockProperty]="'isActive'"
        [hasAdd]="true"
        [isDeletableShow]="false"
        [isDeletableEnabled]="false"
        [isEditableShow]="permissionService.is(permissionService.systemActionRoles.MERCHANT_EDIT_BUTTON_SHOW)"
        [isEditableEnabled]="permissionService.is(permissionService.systemActionRoles.MERCHANT_EDIT_BUTTON_ENABLED)"
        (onSelectionChange)="onSelectionChange($event)"
        [currentTab]="currentTab"
        [userType]="userType"
        [buttons]="tableButtons"
        (buttonAction)="handleTableAction($event)">
    </table-responsive>
    <div footer>
        <div fxFlex fxLayout="row" fxLayoutAlign="center center"
            fxLayoutGap="4">
            <div fxFlex>
                <button 
                    class="action-button"
                    mat-raised-button
                    [disabled]="!selection"
                    (click)="generateReports()">
                    Gerar Relatório
                </button>
            </div>
            <div fxFlex>

            </div>
            <div fxFlex>

            </div>
            <div fxFlex>

            </div>
            <div fxFlex>
                <button *ngIf="viewButtonBack"
                    class="action-button"
                    mat-raised-button
                    (click)="onBack()">
                    VOLTAR
                </button>
                <button *ngIf="viewButtonBack"
                    class="action-button"
                    mat-raised-button
                    color="primary"
                    (click)="onUsers()">
                    USUÁRIOS
                </button>
            </div>
        </div>
    </div>
</app-layout-crud-index>
